/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Instructions_BlurbInputs */



/**
* | output |
* | --- |
* | "Write the job the way you would brief a colleague: what to look at, what to produce, and for whom. Uno can turn a rough note into clear instructions with Ref..." |
*
* @param {Uno_Edu_Agent_Instructions_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_instructions_blurb = /** @type {((inputs?: Uno_Edu_Agent_Instructions_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Instructions_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreiben Sie die Aufgabe so, wie Sie einen Kollegen einweisen würden: was er sich ansehen soll, was dabei herauskommen soll und für wen. Mit „Mit Uno verfeinern“ macht Uno aus einer groben Notiz eine klare Anleitung.")
	return /** @type {LocalizedString} */ ("Write the job the way you would brief a colleague: what to look at, what to produce, and for whom. Uno can turn a rough note into clear instructions with Refine with Uno.")
});